import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const KeepOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default KeepOffSVG;
